export enum InternalExceptionCodes {
  INTERNAL_ERROR = 0,
  CORE_SKILL_NOT_FOUND = 1,
  SCHOOLSIDE_REQUEST = 2,
  USER_EXISTS = 3,
  ADD_BOT_PART_COUNT = 4,
  CORE_SKILL_NOT_APPLIED = 5,
  PART_DISCHANT_INFO = 6,
  USER_BOT_PART_NOT_FOUND = 7,
  USER_BOT_PART_EQUIPPED = 8,
  SWATCH_APPLIED = 9,
  INVENTORY_ITEM_NOT_FOUND = 10,
  EMPTY_ARRAY = 11,
  BOT_CLEAN = 12,
  MARKET_DATA_NOT_FOUND = 13,
  BOT_PART_INFO_NOT_FOUND = 14,
  ITEM_INFO_NOT_FOUND = 15,
  SKILL_ICON_RESOURCE_NOT_FOUND = 16,
  SKILL_ICON_IMAGE_PATH_NOT_FOUND = 17,
  MISSION_REWARDS_EXIST = 18,
  MISSION_REWARD_NOT_FOUND = 19,
  MISSION_REWARD_COLLECTED = 20,
  BONUS_COLLECT_CLASSTIME = 21,
  BONUS_NOT_FOUND = 22,
  BONUS_COLLECT_NOT_GRANTED = 32,
  BONUS_ASK_SCHEDULE = 33,
  BONUS_GRANT_GRANTED = 34,
  BUNDLE_INFO_NOT_FOUND = 35,
  CORRECT_REWARD_SWAP_CLASSTIME = 36,
  CORRECT_REWARD_MILESTONE_NOT_FOUND = 37,
  CORRECT_REWARD_BULBS_COUNT = 38,
  TR_MATCH_NOT_FOUND = 39,
  TR_MATCH_FINISHED = 40,
  TR_MATCH_NOT_BELONG = 41,
  INVENTORY_NOT_ENOUGH_COUNT = 42,
  ENTITY_NOT_EXISTS = 43,
  LEVEL_LOCK = 44,
  USER_NOT_FOUND = 47,
  PERSISTANCE_EXPECTED = 48,
  CONFIG_BAD = 49,
  UNACCEPTABLE_PURCHASE_ATTEMPT = 50,
  MALFORMED_BASE64_IMAGE_META_DATA = 51,
  MOCKED_MODE_REQUIRED = 52,
  INVALID_CONTENT_TYPE = 53,
  MATCH_ALREADY_EXISTS = 54,
  PLAYER_ALREADY_IN_MATCH = 55,
  MATCH_NOT_FOUND = 56,
  MATCH_USER_NOT_FOUND = 57,
  UNEXPECTED_MATCH_START_ERROR = 58,
  PLAYER_NOT_IN_MATCH = 59,
  WRONG_NUMBER_PLAYERS = 60,
  NO_MATCH_TO_UPDATE = 61,
  MATCH_MUST_END_AFTER_START = 62,
  MISSING_MATCH_OUTCOME_CONFIG = 63,
  UNEXPECTED_MATCH_END = 64,
  SOME_TRANSLATIONS_NOT_COMPLETED = 65,
  MISSING_TRANSLATION = 66,
  TRANSLATION_FILE_NOT_FOUND = 67,
  WRONG_NICKNAME_PART_COUNT = 68,
  INVALID_DATE = 69,
  NOT_ENOUGH_COMBINATIONS = 70,
  NON_EXISTANT_NICKNAME_KEY = 71,
  MISMATCH_LOCALES = 72,
  DUP_KEY_EXCEPTION = 73,
  BASE64_IMAGE_NOT_PARSABLE = 74,
  NO_XP_JOBS_FOUND = 75,
  USER_XP_JOBS_TIMEOUT = 76,
  CACHE_METHOD_NOT_SET = 77,
  ENTITY_ALREADY_EXISTS = 78,
  NOT_ENOUGH_CURRENCY = 79,
  MISSING_REQUIRED_PARTS = 80,
  SEASONAL_MARKET_NOT_ACTIVE = 81,
  MISSION_ALREADY_CELEBRATED = 82,
  ITEM_NOT_AVAILABLE_IN_COUNTRY = 83
}
